'use client';
import { CarouselProvider } from '@eliadmin/core/src/components/ui/carousel-context';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HomepageCarousel } from '../../components/homepage/homepage-carousel';
import { useRelatedProducts } from '@eliadmin/core/src/hooks/products/use-related-products';
import { RelatedProductsStatus } from '@eliadmin/core/src/components/product/detail/related-products-status';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
export function ProductRelatedProducts({ slug }: { slug: string }) {
  const { t } = useTranslations();
  const related = useRelatedProducts(slug);
  const products = related.products;
  if (!products.length && !related.isLoading && !related.isError) return null;
  return (
    <>
      {' '}
      {products.length > 0 && (
        <CarouselProvider>
          <HomepageCarousel
            title={t('text744')}
            products={products}
            className={{
              section: cn(
                'pb-12 pt-10 sm:pb-20 sm:pt-14 lg:pb-24 lg:pt-20',
                'ea-product-page__related-products-section',
              ),
            }}
          />
        </CarouselProvider>
      )}{' '}
      <div className="mx-auto w-full max-w-screen-2xl px-4">
        <RelatedProductsStatus
          loading={related.isLoading}
          error={related.isError}
          retry={() => {
            void related.refetch();
          }}
        />
      </div>{' '}
    </>
  );
}
